import { isPixelAccessor, type PixelAccessor } from "./PixelAccessor";

/**
 * Image pixel accessor interface.
 */
export interface PixelAccessorWithDimensions extends PixelAccessor {
  /**
   * Width
   */
  readonly width: number;

  /**
   * Height
   */
  readonly height: number;
}

/**
 * Checks if given argument is PixelAccessorWithDimensions.
 *
 * @param obj
 */
export function isPixelAccessorWithDimensions(
  obj: unknown
): obj is PixelAccessorWithDimensions {
  return (
    typeof isPixelAccessor(obj) &&
    typeof (obj as Partial<PixelAccessorWithDimensions>).width === "number" &&
    typeof (obj as Partial<PixelAccessorWithDimensions>).height === "number"
  );
}
